import React, {useEffect, useState} from "react";

import {Modal, Typography} from "antd";
const { Paragraph } = Typography;

export default function BrowserSizeModal() {
    const [modal, setModal] = useState(false);

    useEffect(() => {
        function handleResize() {
            const height = window.innerHeight;
            const width = window.innerWidth;
            if (height < 600 || width < 1000) {
                setModal(true);
            } else {
                setModal(false);
            }
        }

        window.addEventListener('resize', handleResize)
    });

    return (<>
        <Modal
            title={`Study not supported on Phones or Tablets`}
            open={modal}
            closable={false}
            footer={null}
        >
            <Paragraph>
                This study is not supported on phones or tablets.
                Please switch to a desktop or laptop computer.
            </Paragraph>
            <Paragraph>
                If you are already on a desktop or laptop, and are receiving this message,
                please increase the size of your browser.
            </Paragraph>
        </Modal>
    </>);
}